<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Modal from 'dashboard/components/Modal.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  unit: { type: Object, default: null },
  inboxes: { type: Array, default: () => [] },
});

const emit = defineEmits(['close', 'submit']);
const { t } = useI18n();

const selected = ref([]);

watch(
  () => [props.show, props.unit],
  () => {
    if (!props.show || !props.unit) return;
    selected.value = [...(props.unit.inbox_ids || [])];
  },
  { immediate: true }
);

const onSubmit = () =>
  emit('submit', { id: props.unit.id, inboxIds: selected.value });
</script>

<template>
  <Modal :show="show" @close="emit('close')">
    <form class="flex flex-col gap-4 p-8" @submit.prevent="onSubmit">
      <div class="flex flex-col gap-1">
        <h3 class="text-base font-medium text-n-slate-12">
          {{ t('ORG_ACCESS.CHANNELS.TITLE', { name: unit?.name }) }}
        </h3>
        <p class="text-sm text-n-slate-11">
          {{ t('ORG_ACCESS.CHANNELS.DESCRIPTION') }}
        </p>
      </div>

      <div class="flex flex-col gap-2 max-h-80 overflow-y-auto">
        <label
          v-for="inbox in inboxes"
          :key="inbox.id"
          class="flex items-center gap-2 text-sm text-n-slate-12"
        >
          <input v-model="selected" type="checkbox" :value="inbox.id" />
          {{ inbox.name }}
        </label>
      </div>

      <div class="flex items-center justify-end gap-2">
        <Button
          type="button"
          variant="ghost"
          :label="t('ORG_ACCESS.UNIT_FORM.CANCEL')"
          @click="emit('close')"
        />
        <Button type="submit" :label="t('ORG_ACCESS.CHANNELS.SAVE')" />
      </div>
    </form>
  </Modal>
</template>
